import { OnInit, Component, ViewChild } from '@angular/core';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { IMyDateModel, IAngularMyDpOptions } from 'angular-mydatepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { ISelect } from 'app/shared/models/select.model';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { ValidatorService } from 'app/shared/services/validator.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalEmployeesComponet } from 'app/views/modales/employees/modal-employees.component';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { WorkLeaveService } from '../workLeave.service';
import { IDtoWorkLeave } from 'app/shared/models/request/work-leave/dto-work-leave.model';
import { MatRadioChange } from '@angular/material';
import { IDtoPeriodType } from 'app/shared/models/employee/dto-period-type.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../../security/identity.service';
import { PayrollService } from '../../payroll.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-work-leave',
    styleUrls: ['work-leave.style.scss'],
    templateUrl: 'work-leave.template.html'
})
export class WorkLeaveComponent implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Notificaciones */
    @ViewChild('addSwal', { static: false }) private addSwal: SwalComponent;
    /**Formularios */
    private formWorkLeave: FormGroup;
    private locale: string = 'es';
    /**Catalogos */
    private catalogLineInsurances: Observable<ISelect[]>;
    private catalogPaymentTypes: Observable<ISelect[]>;
    /**Modales */
    private modalRef: BsModalRef;
    private configModal = {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
    };
    private employee: IDtoEmployee;
    private employeePeriod: IDtoPeriodType;
    private hasEmployee = false;
    private pickerOptionsPayroll: IAngularMyDpOptions;
    private currentDate: Date;
    private isRecountable: boolean = undefined;
    private isOther: boolean;
    constructor(private formBuilder: FormBuilder
        , private configGeneral: AppConfig
        , private spinner: NgxSpinnerService
        , private workLeaveService: WorkLeaveService
        , private configurationService: ConfigurationService
        , private modalService: BsModalService
        , private identityService: IdentityService
        , private payrollService: PayrollService) {

    }
    ngOnInit(): void {
        if (this.configurationService.isReady) {
            this.spinner.show();
            this.getCatalogs();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.spinner.show();
                this.getCatalogs();
            });
        }
        this.initializeFormWorkLeave();
    }
    private getCatalogs(): void {
        this.catalogLineInsurances = this.workLeaveService.getCatalogLineInsurances();
        this.catalogPaymentTypes = this.workLeaveService.getCatalogPaymentTypes();
        this.workLeaveService.getCurrentDate().subscribe(x => {
            this.currentDate = new Date(x);
        });
        this.spinner.hide();
    }
    private initializeFormWorkLeave() {
        this.formWorkLeave = this.formBuilder.group({
            dismissalCauseId: [null, Validators.required],
            dismissalDate: [null, Validators.required],
            canGenerateVacancy: [null, Validators.required],
            applyBond: [null, Validators.required],
            bondComments: [null],
            hasSettlementRequest: [null, Validators.required],
            settlementComments: [null],
            hasCellPhone: [null, Validators.required],
            cellPhoneObservations: [null],
            hasPendingCommissions: [null, Validators.required],
            commissionComments: [null],
            isRechargeable: [null],
            dismissalObservations: [null],
            isChangePay: [null, Validators.required],
            paymentTypeId: [null],
            employee: [null, Validators.required],
            otherObservations: [null],
            hasChecks: [null, Validators.required],
            checkComments: [null]
        });
    }
    private submitForm(): void {
        if (this.formWorkLeave.valid) {
            this.addSwal.title = 'Se registrará la baja para el empleado seleccionado.';
            this.addSwal.show();
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'error');
            this.configGeneral.touchedControls(this.formWorkLeave);
        }
    }
    private openModalEmployees() {
        this.modalRef = this.modalService.show(ModalEmployeesComponet
            , Object.assign({ class: 'modal-lg' }, this.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                this.formWorkLeave.reset();
                this.employee = result;
                console.log(this.employee);
                this.formWorkLeave.get('employee').setValue(this.employee.employeeName);
                this.hasEmployee = true;
                this.getStartDatePeriod();
            } else {
                this.hasEmployee = false;
            }
        });
    }
    private isOtherCause(text: string): void {
      this.catalogLineInsurances.pipe(take(1)).subscribe((data: ISelect[]) => {
    const filteredData = data.filter((item: ISelect) =>
      item.text.toLowerCase().includes(text.toLowerCase())
    );
    if (filteredData.length > 0 && filteredData[0].additional == 'Recontratable') {
      this.formWorkLeave.get('isRechargeable').setValue(true);
      this.isRecountable = true;
      this.formWorkLeave.get('dismissalObservations').setValidators(null);
      this.formWorkLeave.get('dismissalObservations').setValidators(Validators.maxLength(500));
      this.formWorkLeave.get('dismissalObservations').updateValueAndValidity();
    }
    if (filteredData.length > 0 && filteredData[0].additional == 'No Recontratable') {
      this.formWorkLeave.get('isRechargeable').setValue(false);
      this.formWorkLeave.get('dismissalObservations').setValue(undefined);
      this.formWorkLeave.get('dismissalObservations').setValidators(Validators.maxLength(500));
      this.isRecountable = false;
      this.formWorkLeave.get('dismissalObservations').setValidators([Validators.required]);
      this.formWorkLeave.get('dismissalObservations').setValidators(Validators.maxLength(500));
      this.formWorkLeave.get('dismissalObservations').updateValueAndValidity();
    }
    if (filteredData.length > 0 && filteredData[0].additional == 'Es Recontratable?') {
      this.formWorkLeave.get('isRechargeable').setValue(undefined);
      this.formWorkLeave.get('dismissalObservations').setValue(undefined);
      this.formWorkLeave.get('dismissalObservations').setValidators(Validators.maxLength(500));
      this.isRecountable = undefined;
        this.formWorkLeave.get('isRechargeable').setValidators([Validators.required]);
        this.formWorkLeave.get('isRechargeable').updateValueAndValidity();
    }
  });

        if (text === 'Otra - No Recontratable') {
            this.isOther = true;
            this.formWorkLeave.get('otherObservations').setValidators([Validators.required, Validators.maxLength(500)]);
        } else {
            this.isOther = false;
            this.formWorkLeave.get('otherObservations').setValidators(null);
        }
        this.formWorkLeave.get('otherObservations').updateValueAndValidity();
    }
    private isPreventive($event: MatRadioChange): void {
        if ($event.value) {
            this.formWorkLeave.get('isRelocation').setValue(false);
            this.formWorkLeave.get('canGenerateVacancy').setValue(false);
        } else {
            this.formWorkLeave.get('isRelocation').setValue(null);
            this.formWorkLeave.get('canGenerateVacancy').setValue(null);
        }
    }
    private getDate(event: IMyDateModel) {
        return event.singleDate.jsDate;
    }
    private save(): void {
        this.spinner.show();
        let data = Object.assign({}, this.formWorkLeave.value as IDtoWorkLeave);

        data.employeeId = this.employee.id;
        data.dismissalDate = this.configGeneral.getLocalISOTime(this.getDate(this.formWorkLeave.value.dismissalDate));
        data.codeNomPayroll = this.employee.employeeTypePayrollId;
        data.companyPay = this.employee.employeeCompanyId;
        data.employeeDate = this.employee.hiringDate;

        this.workLeaveService.addWorkLeave(data)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        let d = x.data as IDtoWorkLeave;
                        this.addModuleLog(d.id);
                        this.formWorkLeave.reset();
                        this.hasEmployee = false;
                    }
                    this.spinner.hide();
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private enableBondComments($event: MatRadioChange) {
        if ($event.value) {
            this.formWorkLeave.get('bondComments').setValidators([Validators.required, Validators.maxLength(500)]);
        } else {
            this.formWorkLeave.get('bondComments').setValidators(null);
        }
        this.formWorkLeave.get('bondComments').updateValueAndValidity();
    }
    private enablesettlementComments($event: MatRadioChange) {
        if ($event.value) {
            this.formWorkLeave.get('settlementComments').setValidators([Validators.required, Validators.maxLength(500)]);
        } else {
            this.formWorkLeave.get('settlementComments').setValidators(null);
        }
        this.formWorkLeave.get('settlementComments').updateValueAndValidity();
    }
    private enableCommissionComments($event: MatRadioChange) {
        if ($event.value) {
            this.formWorkLeave.get('commissionComments').setValidators([Validators.required, Validators.maxLength(500)]);
        } else {
            this.formWorkLeave.get('commissionComments').setValidators(null);
        }
        this.formWorkLeave.get('commissionComments').updateValueAndValidity();
    }
    private enableChangePay($event: MatRadioChange) {
        if ($event.value) {
            this.formWorkLeave.get('paymentTypeId').setValidators([Validators.required]);
        } else {
            this.formWorkLeave.get('paymentTypeId').setValidators(null);
        }
        this.formWorkLeave.get('paymentTypeId').updateValueAndValidity();
    }
    private enableIsRechargeable($event: MatRadioChange) {
      if (!$event.value) {
          this.formWorkLeave.get('dismissalObservations').setValidators([Validators.required, Validators.maxLength(500)]);
      } else {
          this.formWorkLeave.get('dismissalObservations').setValidators(Validators.maxLength(500));
      }
      this.formWorkLeave.get('dismissalObservations').updateValueAndValidity();
  }
    private enableCellPhoneObservations($event: MatRadioChange) {
        if ($event.value) {
            this.formWorkLeave.get('cellPhoneObservations').setValidators([Validators.required, Validators.maxLength(500)]);
        } else {
            this.formWorkLeave.get('cellPhoneObservations').setValidators(null);
        }
        this.formWorkLeave.get('cellPhoneObservations').updateValueAndValidity();
    }
    private enableCheckComments($event: MatRadioChange) {
        if ($event.value) {
            this.formWorkLeave.get('checkComments').setValidators([Validators.required, Validators.maxLength(500)]);
        } else {
            this.formWorkLeave.get('checkComments').setValidators(null);
        }
        this.formWorkLeave.get('checkComments').updateValueAndValidity();
    }
    private restrictDatePayroll(year: number, month: number, day: number) {
        this.pickerOptionsPayroll = {
            dateFormat: 'dd.mm.yyyy',
            dateRange: false,
            disableDateRanges: [{
                begin: { year: 1000, month: 1, day: 1 },
                end: { year: year, month: month, day: day }
            }]
        }
    }
    private addModuleLog(id: number): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Dismissals';
        dto.module = 'workLeave';
        dto.action = 'new';
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
    private getStartDatePeriod(): void {
        this.payrollService.getStartDatePeriod(this.employee.employeeCompanyId, this.employee.employeeTypePayrollId, this.configGeneral.dateFormat(this.currentDate, 'yyyy-mm-dd')).subscribe(x => {
            if (x.data != null) {
                let init = new Date(x.data as Date);
                let current = new Date(this.configGeneral.dateFormat(this.currentDate, 'mm/dd/yyyy'));
                let minDate = new Date(this.configGeneral.dateFormat(this.currentDate, 'mm/dd/yyyy'));
                minDate.setDate(minDate.getDate() - 5);
                let count = this.countWeekends(new Date(minDate.valueOf()), current);
                if (count > 0) {
                    minDate.setDate(minDate.getDate() - count);
                }
                if (minDate.getTime() < init.getTime()) {
                    let dif = init.getTime() - minDate.getTime();
                    let daysMin = Math.round(dif / (1000 * 60 * 60 * 24))
                    minDate.setDate(minDate.getDate() + daysMin);
                    let day = minDate.getUTCDate();
                    let month = minDate.getUTCMonth() + 1;
                    let year = minDate.getUTCFullYear();
                    if (day == 1 && month == 1) {
                        this.restrictDatePayroll(year - 1, 12, 31);
                    }
                    if (day == 1) {
                        day = new Date(year, month - 1, 0).getDate();
                        month = month - 1;
                    } else {
                        day = day - 1;
                    }
                    this.restrictDatePayroll(year, month, day);
                } else {
                    let day = minDate.getUTCDate() - 1;
                    let month = minDate.getUTCMonth() + 1;
                    let year = minDate.getUTCFullYear();
                    this.restrictDatePayroll(year, month, day);
                }
            } else {
                let minDate = new Date(this.configGeneral.dateFormat(this.currentDate, 'mm/dd/yyyy'));
                let day = minDate.getUTCDate() - 1;
                let month = minDate.getUTCMonth() + 1;
                let year = minDate.getUTCFullYear();
                this.restrictDatePayroll(year, month, day);
            }
        });
        this.spinner.hide();
    }
    // private prueba(): void {
    //     let init = new Date("08/25/2021");
    //     if (init != null) {
    //         let current = new Date(this.configGeneral.dateFormat(this.currentDate, 'mm/dd/yyyy'));
    //         let minDate = new Date(this.configGeneral.dateFormat(this.currentDate, 'mm/dd/yyyy'));//new Date(this.currentDate.valueOf());
    //         minDate.setDate(minDate.getDate() - 5);
    //         let count = this.countWeekends(new Date(minDate.valueOf()), current);
    //         if (count > 0) {
    //             minDate.setDate(minDate.getDate() - count);
    //         }
    //         if (minDate.getTime() < init.getTime()) {
    //             let dif = init.getTime() - minDate.getTime();
    //             let daysMin = Math.round(dif / (1000 * 60 * 60 * 24))
    //             minDate.setDate(minDate.getDate() + daysMin);
    //             this.restrictDatePayroll(minDate);
    //         } else {
    //             minDate.setDate(minDate.getDate());
    //             this.restrictDatePayroll(minDate);
    //         }
    //     }
    // }
    private countWeekends(init: Date, end: Date): number {
        var timeDiff = Math.abs(end.getTime() - init.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); //Días entre las dos fechas
        var count = 0; //Número de Sábados y Domingos
        var array = new Array(diffDays);

        for (var i = 0; i < diffDays; i++) {
            //0 => Domingo - 6 => Sábado
            if (init.getDay() == 0 || init.getDay() == 6) {
                count++;
            }
            init.setDate(init.getDate() + 1);
        }

        return count;
    }
}
